export const STRING_EXPERIENCE = 'Work Experience';
export const STRING_EDUCATION = 'Education';
export const STRING_OF = 'of';
